import { render, staticRenderFns } from "./search-configurations-list.view.vue?vue&type=template&id=2b1401a7&scoped=true"
import script from "./search-configurations-list.view.vue?vue&type=script&lang=ts"
export * from "./search-configurations-list.view.vue?vue&type=script&lang=ts"
import style0 from "./search-configurations-list.view.vue?vue&type=style&index=0&id=2b1401a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1401a7",
  null
  
)

export default component.exports